import axios from 'axios';
import header from "@/services/header";

const baseUrl = process.env.VUE_APP_BASE_URL;
const apiV1 = process.env.VUE_APP_API_V1;

const Data = async (type) => {
  const t = type || 'banks'
  const banks = await axios.get(`${baseUrl + apiV1}/payment/data/${t}`, header)
  return banks.data.data._embedded.banks || banks.data.data.content
}



export { Data }
